import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../../../../services/AppsService'
import {Bitrix24UsersInServiceHeader} from './Bitrix24UsersInServiceHeader'
import {OneUserInServiceBitrix24} from './OneUserInServiceBitrix24'

const Bitri24UsersInService = () => {
  const {appId} = useParams()
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)
  const users = app?.settings.bitrix24.users_in_service_list
  const sortedUsers = [...users!]
  sortedUsers.sort((a, b) => a.bitrix24_user_id - b.bitrix24_user_id)

  return (
    <table className='table align-middle table-row-dashed fs-7 gy-5 dataTable no-footer'>
      <Bitrix24UsersInServiceHeader personalData={app?.personal_data === true} />
      <tbody>
        {sortedUsers?.map((u) => (
          <OneUserInServiceBitrix24 user={u} key={u.id} />
        ))}
      </tbody>
    </table>
  )
}

export {Bitri24UsersInService}
